export default __webpack_public_path__ + "static/media/marketplaceSales.41e9e2ba.svg";